const bocBoa = require("@/assets/shareNpc/bocBoa.png");
const alwAlp = require("@/assets/shareNpc/alwAlp.png");
const hgsHgcHgh = require("@/assets/shareNpc/hgsHgcHgh.png");
const rctRcm = require("@/assets/shareNpc/rctRcm.png");
const kppKpmKpsKpg = require("@/assets/shareNpc/kppKpmKpsKpg.png");
const beyChy = require("@/assets/shareNpc/beyChy.png");

export default {
  data() {
    return {
      shareNpcImages: {
        bocBoa,
        alwAlp,
        hgsHgcHgh,
        rctRcm,
        kppKpmKpsKpg,
        beyChy,
      },
    };
  },
};
